"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EPSearchPage;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _searchUiAppSearchConnector = _interopRequireDefault(require("@elastic/search-ui-app-search-connector"));
var _config = require("./config");
var _customResult = _interopRequireDefault(require("./custom-result"));
var _searchBoxWrapper = _interopRequireDefault(require("../search-box-wrapper"));
var _reactSearchUi = require("@elastic/react-search-ui");
var _reactSearchUiViews = require("@elastic/react-search-ui-views");
const SORT_OPTIONS = [{
  name: 'Relevance',
  value: '',
  direction: ''
}, {
  name: 'Name (A-Z)',
  value: 'name',
  direction: 'asc'
}, {
  name: 'Name (Z-A)',
  value: 'name',
  direction: 'desc'
}];
const FACET_FIELDS = [{
  name: 'design_language',
  label: 'Design Language'
}, {
  name: 'component_library',
  label: 'Component Library'
}, {
  name: 'backwards_compat',
  label: 'Backwards Compat'
}, {
  name: 'availability',
  label: 'Availability'
}];
function EPSearchPage({
  connectorConfig,
  ...searchBoxProps
}) {
  return /*#__PURE__*/_react.default.createElement(_reactSearchUi.SearchProvider, {
    config: {
      ..._config.config,
      apiConnector: new _searchUiAppSearchConnector.default(connectorConfig),
      trackUrlState: false
    }
  }, /*#__PURE__*/_react.default.createElement(_reactSearchUi.WithSearch, {
    mapContextToProps: ({
      wasSearched
    }) => ({
      wasSearched
    })
  }, ({
    wasSearched
  }) => {
    return /*#__PURE__*/_react.default.createElement(_reactSearchUiViews.Layout, {
      header: /*#__PURE__*/_react.default.createElement(_searchBoxWrapper.default, searchBoxProps),
      sideContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, wasSearched && /*#__PURE__*/_react.default.createElement(_reactSearchUi.Sorting, {
        label: "Sort By",
        sortOptions: SORT_OPTIONS
      }), FACET_FIELDS.map(({
        name,
        label
      }) => /*#__PURE__*/_react.default.createElement(_reactSearchUi.Facet, {
        key: name,
        field: name,
        label: label,
        view: _reactSearchUiViews.MultiCheckboxFacet,
        filterType: "any"
      }))),
      bodyHeader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, wasSearched && /*#__PURE__*/_react.default.createElement(_reactSearchUi.PagingInfo, null)),
      bodyContent: /*#__PURE__*/_react.default.createElement(_reactSearchUi.Results, {
        resultView: _customResult.default,
        titleField: "name",
        urlField: "url"
      }),
      bodyFooter: /*#__PURE__*/_react.default.createElement(_reactSearchUi.Paging, null)
    });
  }));
}
EPSearchPage.propTypes = {
  connectorConfig: _propTypes.default.shape({
    searchKey: _propTypes.default.string,
    engineName: _propTypes.default.string,
    endpointBase: _propTypes.default.string
  }),
  ..._searchBoxWrapper.default.propTypes
};